// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1nDzQ","modalForm":"UpgradeEpcsModal_modalForm__34-p6","modalFooter":"UpgradeEpcsModal_modalFooter__3ndVN"};